import { GetGameStateResult } from "results/frankenstories/GetGameStateResult";

export const useCopyStory = (props: { gameState?: GetGameStateResult }) => {
    const { gameState } = props;

    let copiedStory = gameState?.title ?? "";

    if (gameState) {
        for (const s of gameState.story) {
            copiedStory += `
            
${s.body}`;
        }
    }

    return { copiedStory };
};
